module.exports = __webpack_public_path__ + "/images/shop/icon/b2b_cash_on_delivery.svg";